import jsPDF from 'jspdf';
import 'jspdf-autotable';
import mavenProBase64 from './mavenProBase64';
import { defaultGrid } from './gridLogic';
import { listarImagenesDelGrid, cargarImagenComoDataURL, dibujarEtiquetaConGrid } from './gridToPdfRenderer';

// Genera el PDF de etiquetas para dorsales. La matemática de posición por
// página/columna/fila (x, y, salto de página) es la que ya existía y
// funcionaba antes de que esta vista tuviera tab propio — se conserva tal
// cual. El dibujo de CADA etiqueta ahora lo hace gridToPdfRenderer.js según
// el grid configurado en la Fase 3 (o defaultGrid() si el evento nunca lo
// personalizó, que reproduce en estructura el diseño original).
//
// Es async porque las celdas de imagen pueden apuntar a una foto subida a
// Storage: jsPDF no puede resolver esa URL por sí mismo, hay que precargar
// los datos de la imagen antes de dibujar (ver gridToPdfRenderer.js).
export async function generarEtiquetasPDF({
  participantesSeleccionados,
  config,
  eventSubEventsRegistry,
  valueRemap,
  atributosDisponibles,
  grid,
}) {
  const {
    etiquetaAncho, // mm
    etiquetaAlto, // mm
    margenIzquierdo, // mm
    margenSuperior, // mm
    separacionHorizontal, // mm
    separacionVertical, // mm
    columnas,
    filas,
  } = config;

  const doc = new jsPDF({ unit: 'mm', format: 'letter' });

  if (!doc.getFontList()['MavenPro']) {
    doc.addFileToVFS('MavenProLight-100.otf', mavenProBase64);
    doc.addFont('MavenProLight-100.otf', 'MavenPro', 'normal');
    doc.setFont('MavenPro');
  }

  const etiquetasPorPagina = columnas * filas;

  // La selección de participantes es la autoridad: se excluye solo a quien
  // no tenga número de dorsal válido (una etiqueta sin número no tiene
  // sentido), y se reporta para que el llamador avise al admin.
  const omitidos = [];
  const participantesValidos = (participantesSeleccionados || [])
    .filter((p) => {
      const tieneNumero =
        p.numero !== undefined && p.numero !== null && p.numero !== '' && p.numero !== 'Liberado';
      if (!tieneNumero) {
        omitidos.push({
          nombres: p.nombres,
          apellidos: p.apellidos,
          motivo: 'sin número de dorsal asignado',
        });
      }
      return tieneNumero;
    })
    .sort((a, b) => a.numero - b.numero);

  const gridAUsar = grid && Array.isArray(grid.columns) && grid.columns.length > 0 ? grid : defaultGrid();

  const atributosPorKey = {};
  (atributosDisponibles || []).forEach((a) => {
    atributosPorKey[a.key] = a;
  });
  const contexto = { valueRemap, atributosPorKey, eventSubEventsRegistry };

  const imagenesCache = {};
  const urlsImagenes = listarImagenesDelGrid(gridAUsar);
  await Promise.all(
    urlsImagenes.map((url) =>
      cargarImagenComoDataURL(url)
        .then((dataUrl) => {
          imagenesCache[url] = dataUrl;
        })
        .catch(() => {
          // si falla la descarga (ej. sin conexión), esa celda simplemente
          // no dibuja imagen en vez de tronar la generación completa
        })
    )
  );

  participantesValidos.forEach((dato, index) => {
    const posicionEnPagina = index % etiquetasPorPagina;

    if (posicionEnPagina === 0 && index !== 0) {
      doc.addPage();
    }

    const col = posicionEnPagina % columnas;
    const row = Math.floor(posicionEnPagina / columnas);

    const x = margenIzquierdo + col * (etiquetaAncho + separacionHorizontal);
    const y = margenSuperior + row * (etiquetaAlto + separacionVertical);

    doc.setDrawColor(0);
    doc.setLineWidth(0.1);

    dibujarEtiquetaConGrid(doc, gridAUsar, dato, x, y, etiquetaAncho, etiquetaAlto, contexto, imagenesCache);
  });

  if (participantesValidos.length > 0) {
    doc.save('etiquetas.pdf');
  }

  return { generados: participantesValidos.length, omitidos };
}
